import * as React from 'react'
import { connect } from 'react-redux'

import List from '@material-ui/core/List'
import LanguageIcon from '@material-ui/icons/Language'
import { FormattedMessage } from 'react-intl'

import { InjectedLangContextProps, withLanguage } from '../../contexts/Language'
import { ApplicationState, Locale, selectThemeType, toggleThemeType } from '../../redux/ducks'
import { FullScreenDialog } from './index'
import Setting from './Setting'

interface SettingsDialogProps {
  changeLanguage: (locale: Locale) => void
  close: () => void
  isOpen: boolean
  settings: {
    locale: Locale,
  }
}

const mstp = (state: ApplicationState) => ({ isDark: selectThemeType(state) })

const actions = { toggleThemeType }

type Props =
  SettingsDialogProps
  & typeof actions
  & ReturnType<typeof mstp>

const SettingsDialog = ({
  changeLanguage,
  toggleThemeType,
  close,
  isDark,
  isOpen,
  settings,
  language:
  {
    locales,
    localeNames,
    locale,
  },
}: Props & InjectedLangContextProps) => {
  const phrasing = {
    language: <FormattedMessage id={'dictionary.language'} />,
    darkMode: <FormattedMessage id={'labels.darkMode'} />,
    active: <FormattedMessage id={'dictionary.active'} />,
    inactive: <FormattedMessage id={'dictionary.inactive'} />,
  }

  return (
    <FullScreenDialog
      isOpen={isOpen}
      close={close}
      title={'settings'}
    >
      <List>
        <Setting
          primary={phrasing.language}
          secondary={localeNames[settings.locale]}
          Icon={LanguageIcon}
          listItemProps={{ button: true }}
          selectDialogProps={{
            onSave: changeLanguage,
            initialSelected: locale,
            options: locales.map(localeKey => ({
              name: localeNames[localeKey],
              value: localeKey,
            })),
          }}
        />

      </List>
    </FullScreenDialog>
  )
}

export default withLanguage<SettingsDialogProps>(connect(mstp, actions)(SettingsDialog) as any)



// WEBPACK FOOTER //
// ./src/components/molecules/SettingsDialog.tsx